var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageStatus === 'loading')?_c('loading'):(_vm.pageStatus === 'reservation-not-found')?_c('div',[_c('ReservationNotFound')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }